// extracted by mini-css-extract-plugin
module.exports = {"header":"Route_header__2qA5A","title":"Route_title__3gfI-","description":"Route_description__3yFO_"};